import './rawResponseViewer.css';

interface RawResponseViewerProps {
  data?: string | object | null | undefined;
}

export const RawResponseViewer: React.FC<RawResponseViewerProps> = ({
  data
}) => {
  let content: string;
  let isHtml = false;

  if (typeof data === 'string') {
    content = data;
    isHtml = /^(\s*<!DOCTYPE html>|<html[\s>])/i.test(data);
  } else {
    try {
      content = JSON.stringify(data, null, 2);
    } catch {
      content = String(data);
    }
  }

  return (
    <div className="raw-response-viewer">
      {isHtml
? (
        <iframe
          title="HTML Response"
          className="raw-response-viewer__iframe"
          srcDoc={content}
        />
      )
: (
        <pre className="raw-response-viewer__pre">{content}</pre>
      )}
    </div>
  );
};
